var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTutorialDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4106_5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 17.25,
    width: 14.67,
    height: 2,
    fill: "#8E9FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 18.9409C13.4333 18.3742 11.8 17.9409 10.6667 17.9409C9.56667 17.9409 8.43333 18.1409 7.5 18.6409C7.43333 18.6742 7.4 18.6742 7.33333 18.6742C7.16667 18.6742 7 18.5075 7 18.3409V8.60754C7.4 8.30754 7.83333 8.10754 8.33333 7.94088C9.07333 7.70754 9.88667 7.60754 10.6667 7.60754C11.9667 7.60754 13.3667 7.87421 14.3333 8.60754C15.3 7.87421 16.7 7.60754 18 7.60754C18.78 7.60754 19.5933 7.70754 20.3333 7.94088C20.8333 8.10754 21.2667 8.30754 21.6667 8.60754V18.3409C21.6667 18.5075 21.5 18.6742 21.3333 18.6742C21.2667 18.6742 21.2333 18.6742 21.1667 18.6409C20.2333 18.1409 19.1 17.9409 18 17.9409C16.8667 17.9409 15.2333 18.3742 14.3333 18.9409ZM13.6667 9.60754C12.76 9.20754 11.56 8.94088 10.6667 8.94088C9.86667 8.94088 9.06667 9.04088 8.33333 9.27421V16.9409C9.06667 16.7075 10.6667 16.7297 10.6667 16.7297C10.6667 16.7297 12.76 16.8742 13.6667 17.2742V9.60754ZM15 17.2742C15.9067 16.8742 17.1067 16.6075 18 16.6075C18.8 16.6075 19.6 16.7075 20.3333 16.9409V9.27421C19.6 9.04088 18.8 8.94088 18 8.94088C17.1067 8.94088 15.9067 9.20754 15 9.60754V17.2742Z",
    fill: "#8E9FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 13L16.75 14.299L16.75 11.701L19 13Z",
    fill: "#8E9FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4545 12.8182H13V13.1818H12.4545V12.8182ZM9 12.8182H9.54545V13.1818H9V12.8182ZM11.1818 11V11.5455H10.8182V11H11.1818ZM9.71273 11.4545L10.1 11.8436L9.84182 12.1L9.45455 11.7145L9.71273 11.4545ZM11.9 11.8418L12.2855 11.4545L12.5455 11.7145L12.1582 12.1L11.9 11.8418ZM11 11.9091C11.2893 11.9091 11.5668 12.024 11.7714 12.2286C11.976 12.4332 12.0909 12.7107 12.0909 13C12.0909 13.4036 11.8709 13.7564 11.5455 13.9455V14.2727C11.5455 14.3209 11.5263 14.3672 11.4922 14.4013C11.4581 14.4354 11.4119 14.4545 11.3636 14.4545H10.6364C10.5881 14.4545 10.5419 14.4354 10.5078 14.4013C10.4737 14.3672 10.4545 14.3209 10.4545 14.2727V13.9455C10.1291 13.7564 9.90909 13.4036 9.90909 13C9.90909 12.7107 10.024 12.4332 10.2286 12.2286C10.4332 12.024 10.7107 11.9091 11 11.9091ZM11.3636 14.6364V14.8182C11.3636 14.8664 11.3445 14.9126 11.3104 14.9467C11.2763 14.9808 11.23 15 11.1818 15H10.8182C10.77 15 10.7237 14.9808 10.6896 14.9467C10.6555 14.9126 10.6364 14.8664 10.6364 14.8182V14.6364H11.3636ZM10.8182 14.0909H11.1818V13.7036C11.4964 13.6236 11.7273 13.3382 11.7273 13C11.7273 12.8071 11.6506 12.6221 11.5143 12.4857C11.3779 12.3494 11.1929 12.2727 11 12.2727C10.8071 12.2727 10.6221 12.3494 10.4857 12.4857C10.3494 12.6221 10.2727 12.8071 10.2727 13C10.2727 13.3382 10.5036 13.6236 10.8182 13.7036V14.0909Z",
    fill: "#8E9FD0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    stroke: "#8E9FD0",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4106_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialDark);
export default __webpack_public_path__ + "static/media/Tutorial_dark.b1b94f0dae60ff1de36636ad05fe410b.svg";
export { ForwardRef as ReactComponent };